import type {
  QuantityButtonsVariant,
  QuantityButtonsWidgetConfig,
  ResolvedQuantityButtonsDeviceConfig,
  WidgetDeviceType,
} from "@intelligems/ig-types";
import { merge } from "@intelligems/ig-utils";

export function getDefaultDeviceConfig(
  device: WidgetDeviceType,
  variant: QuantityButtonsVariant = "quantityButtonsWidgetClassic"
) {
  const config: ResolvedQuantityButtonsDeviceConfig = {
    device,
    variant,
    styles: {
      colors: {
        primary: "#F1F1F1",
        secondary: "#E0E0E0",
        border: "#BBBBBB",
      },
      backgroundColors: {
        buttonInactiveBackground: "rgba(0, 0, 0, .05)",
        buttonActiveBackground: "#FFF",
        buttonBorderColor: "#000",
        badgeColor: "#000",
        freeGiftBackground: "rgba(0, 0, 0, 0.10)",
        freeShippingBackground: "rgba(0, 0, 0, 0.10)",
      },
      textColors: {
        sectionTitle: "#000",
        buttonTitle: "#000",
        label: "#666",
        subtitle: "#666",
        price: "#000",
        comparePrice: "#666",
        badge: "#FFF",
        freeGiftLabel: "rgba(0, 0, 0, 0.80)",
        freeShippingLabel: "rgba(0, 0, 0, 0.80)",
        freeGiftCompareAtPrice: "#666",
      },
      typography: {
        sectionTitle: {
          fontSize: "14px",
          fontStyle: "medium",
        },
        subtitle: {
          fontSize: "12px",
          fontStyle: "light",
        },
        buttonTitle: {
          fontSize: "14px",
          fontStyle: "medium",
        },
        price: {
          fontSize: "14px",
          fontStyle: "medium",
        },
        comparePrice: {
          fontSize: "12px",
          fontStyle: "light",
        },
        label: {
          fontSize: "10px",
          fontStyle: "regular",
        },
        badge: {
          fontSize: "11px",
          fontStyle: "medium",
        },
        freeGiftLabel: {
          fontSize: "14px",
          fontStyle: "medium",
        },
        freeShippingLabel: {
          fontSize: "14px",
          fontStyle: "medium",
        },
        freeGiftCompareAtPrice: {
          fontSize: "12px",
          fontStyle: "regular",
        },
      },
      appearance: {
        cornerRadius: 10,
        spacing: "12px",
        layout: "column",
      },
    },
    variables: {
      buttons: [],
      textReplacements: {
        each: "each",
        save: "save",
        off: "off",
        percent: "%",
        fullPriceMessage: "",
      },
    },
  };
  return config;
}

export function resolveDesktopQuantityButtonsConfig(
  config: QuantityButtonsWidgetConfig
) {
  const result = merge(
    getDefaultDeviceConfig("desktop", config.desktop?.variant),
    config.desktop
  );
  result.variables.buttons.sort((a, b) => a.quantity - b.quantity);
  return result;
}

export function resolveMobileQuantityButtonsConfig(
  config: QuantityButtonsWidgetConfig
) {
  const result = merge(
    getDefaultDeviceConfig(
      "mobile",
      config.mobile?.variant ?? config.desktop?.variant
    ),
    (merger) => {
      merger.merge(config.desktop);
      merger.merge(config.mobile);
    }
  );
  result.variables.buttons.sort((a, b) => a.quantity - b.quantity);
  return result;
}

export function resolveQuantityButtonsConfig(
  config: QuantityButtonsWidgetConfig
) {
  return {
    desktop: resolveDesktopQuantityButtonsConfig(config),
    mobile: resolveMobileQuantityButtonsConfig(config),
  };
}
